import { useEffect, useState } from "react";
import { postAxios } from "../../util/apiCall";
import { validateRole, hasRole } from "../../util/utilFunction";
import { today, noFormat } from "../../util/formatDate";
import { v4 as uuidv4 } from "uuid";
import { getBulanNow } from "../../util/formatDate";
import moment from "moment";
import * as XLSX from "xlsx";

export const useSecondProcess = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);
  const v4Id = uuidv4();

  const [produkMasukSP, setProdukMasukSP] = useState("Pilih Produk");
  const [customerSP, setCustomerSP] = useState("Pilih Customer");
  const [jumlahMasukSP, setJumlahMasukSP] = useState("");
  const [listProduk, setListProduk] = useState();
  const [listProdukPrinting, setListProdukPrinting] = useState();
  const [subMenuPrinting, setSubMenuPrinting] = useState("laporan");

  const [dateLaporanSP, setDateLaporanSP] = useState(today);
  const [warnaPrinting, setWarnaPrinting] = useState("Pilih Warna");
  const [dataProdukPick, setDataProdukPick] = useState();
  const [mesinSP, setMesinSP] = useState("Pilih Mesin");
  const [jenisPekerjaan, setJenisPekerjaan] = useState("Pilih Jenis Pekerjaan");
  const [produkLaporanSP, setProdukLaporanSP] = useState("Pilih Produk");
  const [keteranganLaporanSP, setKeteranganLaporanSP] = useState("");
  const [jumlahOkLaporanSP, setJumlahOkLaporanSP] = useState("");
  const [rejectLaporanSP, setRejectLaporanSP] = useState("");
  const [repairLaporanSP, setRepairLaporanSP] = useState("");
  const [jumlahPengerjaanSP, setJumlahPengerjaanSP] = useState("");
  const [errMsgLaporanSP, setErrMsgLaporanSP] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [dataReject, setDataReject] = useState([]);
  const [dataRepair, setDataRepair] = useState([]);
  const [addPopUpNewReject, setAddPopUpNewReject] = useState(false);
  const [addPopUpNewRepair, setAddPopUpNewRepair] = useState(false);
  const [bagianReject, setBagianReject] = useState("");
  const [rejectDescProduksi, setRejectDescProduksi] = useState();
  const [shiftProduksi, setShiftProduksi] = useState("Pilih Shift");
  const [jumlahReject, setJumlahReject] = useState("");
  const [downtime, setDowntime] = useState("");
  const [alasanRejectSP, setAlasanRejectSP] = useState("Pilih Alasan");
  const [dateReject, setDateReject] = useState(today);
  const [dataBarangSP, setDataBarangSP] = useState();
  const [dataBarangPolos, setDataBarangPolos] = useState();
  const [idBarangPolos, setIdBarangPolos] = useState("Pilih Produk");

  const [dataListSP, setDataListSP] = useState();
  const [isRefresh, setIsRefresh] = useState(false);
  const [bulanRejectProduksi, setBulanRejectProduksi] = useState(getBulanNow);
  const [tahunRejectProduksi, setTahunRejectProduksi] = useState(
    moment().utcOffset("+0700").year()
  );

  const [dataPackingList, setDataPackingList] = useState([]);
  const [addPopUpNewPacking, setAddPopUpNewPacking] = useState(false);
  const [datePacking, setDatePacking] = useState(today);
  const [shiftPacking, setShiftPacking] = useState("");
  const [mesinPacking, setMesinPacking] = useState("");
  const [operatorPacking, setOperatorPacking] = useState("");
  const [keteranganPacking, setKeteranganPacking] = useState("");
  const [jumlahPacking, setJumlahPacking] = useState("");

  const [rejectPick, setRejectPick] = useState("");

  const [isErr, setIsErr] = useState(false);

  const [alasanRepairSP, setAlasanRepairSP] = useState("Pilih Alasan");
  const [jumlahRepair, setJumlahRepair] = useState("");

  const [errReject, setErrReject] = useState({});
  const [errRepair, setErrRepair] = useState({});

  const clearErrReject = (key) => setErrReject((p) => ({ ...p, [key]: false }));
  const clearErrRepair = (key) => setErrRepair((p) => ({ ...p, [key]: false }));

  const closePopupReject = () => {
    setAddPopUpNewReject(false);
    setErrReject({});
  };
  const closePopupRepair = () => {
    setAddPopUpNewRepair(false);
    setErrRepair({});
  };

  useEffect(() => {
    if (hasRole(dataUser, "produksi_admin", "ppic_admin", "produksi_leader")) {
      setSubMenuPrinting("rejectProduksi");
    }
  }, []);

  useEffect(() => {
    if (subMenuPrinting === "rejectProduksi") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/checkSheet`,
        {
          tim: dataUser.tim,
          month: `${bulanRejectProduksi} ${tahunRejectProduksi}`,
          produk: "",
          jenisPekerjaan: "",
          bagian: "",
        },
        dataUser.auth,
        setDataListSP,
        ""
      );
      setIsRefresh(false);
    }
  }, [isRefresh, subMenuPrinting, bulanRejectProduksi, tahunRejectProduksi]);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/secondProcess`,
      { tim: dataUser.tim, bagian: validateRole(), type: "getProduk" },
      dataUser.auth,
      setListProduk,
      ""
    );
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListPerincian`,
      {},
      dataUser.auth,
      setRejectDescProduksi,
      ""
    );
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListMold`,
      { tim: dataUser.tim },
      dataUser.auth,
      setDataBarangSP,
      ""
    );
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/secondProcess`,
      {
        tim: dataUser.tim,
        type: "getBarangPolos",
        bagian: validateRole(),
      },
      dataUser.auth,
      setDataBarangPolos,
      ""
    );
  }, []);

  useEffect(() => {
    listProduk &&
      listProduk.find((o) =>
        o.customer === customerSP ? setDataProdukPick(o.data) : ""
      );
  }, [customerSP]);

  let dataMerge = [];

  dataListSP &&
    dataListSP.forEach((element) => {
      element.dataReject &&
        element.dataReject.forEach((obj) => {
          if (obj.bagian === "Produksi") {
            dataMerge.push({
              bagian: obj.bagian,
              dateReject: obj.dateReject,
              id: obj.id,
              reject: obj.reject,
              shift: obj.shift,
              produk: element.barangPolos.produk,
              color: element.barangPolos.color,
              customer: element.customer,
              from: element.bagian,
              date: element.date,
            });
          }
        });
    });

  const handlePickCustomer = (e) => {
    setCustomerSP(e);

    const find =
      dataBarangSP && dataBarangSP.find((x) => (x.company === e ? x : ""));
    let data = [];

    for (let index = 0; index < find.data.length; index++) {
      const element = find.data[index];
      const found = data.some((el) => el.namaBarang === element.namaBarang);
      if (element.bagian === validateRole() && !found) {
        data.push(element);
      }
    }
    setListProdukPrinting(data);
  };

  const handlePickBagian = (data) => {
    setBagianReject(data);
    setErrReject({});
    if (data === "SP") {
      setJumlahReject("");
      setAlasanRejectSP("Pilih Alasan");
    } else if (data === "Produksi") {
      setShiftProduksi("Pilih Shift");
      setJumlahReject("");
    }
  };

  const addFields = () => {
    const err = {};
    if (!bagianReject) err.bagian = true;
    if (bagianReject === "SP" && alasanRejectSP === "Pilih Alasan")
      err.alasan = true;
    if (bagianReject === "Produksi") {
      if (!rejectPick || !rejectPick.label) err.rejectPick = true;
      if (shiftProduksi === "Pilih Shift") err.shift = true;
    }
    if (!jumlahReject || Number(jumlahReject) <= 0) err.jumlah = true;

    if (Object.keys(err).length > 0) {
      setErrReject(err);
      return; // popup tetap terbuka
    }

    const newfield =
      bagianReject === "SP"
        ? {
            dateReject,
            id: alasanRejectSP,
            reject: jumlahReject,
            bagian: "SP",
          }
        : {
            dateReject,
            id: rejectPick.label,
            shift: shiftProduksi,
            reject: jumlahReject,
            bagian: "Produksi",
          };

    setDataReject([...dataReject, newfield]);
    setRejectPick("");
    setErrReject({});
    setAddPopUpNewReject(false);
    setShiftProduksi("Pilih Shift");
    setJumlahReject("");
    setAlasanRejectSP("Pilih Alasan");
    setBagianReject("");
  };

  const removeFields = () => {
    let data = [...dataReject];
    if (data.length > 0) {
      data.splice(data.length - 1);
      setDataReject(data);
    }
  };

  const addFieldsRepair = () => {
    const err = {};
    if (alasanRepairSP === "Pilih Alasan") err.alasan = true;
    if (!jumlahRepair || Number(jumlahRepair) <= 0) err.jumlah = true;

    if (Object.keys(err).length > 0) {
      setErrRepair(err);
      return;
    }

    setDataRepair([
      ...dataRepair,
      {
        dateRepair: dateReject,
        id: alasanRepairSP,
        repair: jumlahRepair,
        bagian: "SP",
      },
    ]);
    setErrRepair({});
    setAddPopUpNewRepair(false);
    setJumlahRepair("");
    setAlasanRepairSP("Pilih Alasan");
  };

  const removeFieldsRepair = () => {
    let data = [...dataRepair];
    if (data.length > 0) {
      data.splice(data.length - 1);
      setDataRepair(data);
    }
  };

  const addFieldsPacking = () => {
    let newfield = {
      date: datePacking,
      mesin: mesinPacking,
      shift: shiftPacking,
      operator: operatorPacking,
      jumlah: jumlahPacking,
      keterangan: keteranganPacking,
    };
    setDataPackingList([...dataPackingList, newfield]);

    setAddPopUpNewPacking(false);
    setShiftPacking("");
    setOperatorPacking("");
    setMesinPacking("");
    setKeteranganPacking("");
    setJumlahPacking("");
  };

  const removeFieldsPacking = () => {
    let data = [...dataPackingList];
    if (data.length > 0) {
      data.splice(data.length - 1);
      setDataPackingList(data);
    }
  };

  let firstFindFromInventory =
    dataBarangPolos && dataBarangPolos.find((o) => o.company === customerSP);
  let secondFindFromInventory =
    firstFindFromInventory &&
    firstFindFromInventory.data.find((o) => o.id === idBarangPolos.value);

  const foundObject =
    dataProdukPick &&
    dataProdukPick.find((obj) => obj.produk === produkLaporanSP.value);

  const handleKirimLaporanSP = () => {
    const getDate = new Date(dateLaporanSP);
    const month = getDate.getMonth();
    const year = getDate.getFullYear();

    const totalReject = dataReject?.reduce(
      (total, item) => total + Number(item.reject || 0),
      0
    );

    const totalRepair = dataRepair?.reduce(
      (total, item) => total + Number(item.repair || 0),
      0
    );

    const rejectLaporanSPValid =
      rejectLaporanSP == null ||
      rejectLaporanSP === "" ||
      Number(rejectLaporanSP) === 0 ||
      Number(rejectLaporanSP) === totalReject;

    const repairLaporanSPValid =
      repairLaporanSP == null ||
      repairLaporanSP === "" ||
      Number(repairLaporanSP) === 0 ||
      Number(repairLaporanSP) === totalRepair;

    const isValid =
      dataReject &&
      rejectLaporanSPValid &&
      repairLaporanSPValid &&
      dataReject.every((item) => {
        const alasanOk =
          typeof item.id === "string" &&
          item.id.trim() !== "" &&
          item.id !== "Pilih Alasan";

        const shiftOk =
          item.bagian !== "Produksi" ||
          (typeof item.shift === "string" &&
            item.shift.trim() !== "" &&
            item.shift !== "Pilih Shift");

        return alasanOk && shiftOk;
      });

    if (
      customerSP !== "Pilih Customer" &&
      mesinSP !== "Pilih Mesin" &&
      produkLaporanSP !== "Pilih Produk" &&
      jenisPekerjaan !== "Pilih Jenis Pekerjaan" &&
      jumlahOkLaporanSP !== "" &&
      jumlahPengerjaanSP !== "" &&
      idBarangPolos !== "Pilih Produk" &&
      isValid
    ) {
      const validateTarget = () => {
        if (validateRole() === "PR") {
          const data =
            dataProdukPick &&
            dataProdukPick.find((x) =>
              x.produk === foundObject.produk ? x : ""
            );
          if (jenisPekerjaan === "Print") {
            return data.targetPrint;
          } else if (jenisPekerjaan === "Pasang Sticker") {
            return data.targetPasangStiker;
          } else if (jenisPekerjaan === "Punching") {
            return data.targetPunching;
          }
        } else {
          const data =
            dataProdukPick &&
            dataProdukPick.find((x) =>
              x.produk === foundObject.produk ? x : ""
            );
          if (jenisPekerjaan === "Ultrasonic") {
            return data.targetUltrasonic;
          } else if (jenisPekerjaan === "Test Bocor") {
            return data.targetTestBocor;
          } else if (jenisPekerjaan === "Filling Plug") {
            return data.targetFilling;
          } else if (jenisPekerjaan === "Pasang Handle") {
            return data.targetPasangHandle;
          } else if (jenisPekerjaan === "Pemasangan BNW") {
            return data.targetBnw;
          } else if (jenisPekerjaan === "Pemasangan Valve & Filter") {
            return data.targetValveFilter;
          } else if (jenisPekerjaan === "Putus Ronce") {
            return data.targetPutusRonce;
          } else if (jenisPekerjaan === "Sortir") {
            return data.targetSortir;
          } else if (jenisPekerjaan === "Pemasangan Elbow") {
            return data.targetFilling;
          } else if (jenisPekerjaan === "Pemasangan MF") {
            return data.targetFilling;
          } else if (jenisPekerjaan === "Pemasangan Filter Arrestor") {
            return data.targetFilling;
          } else if (jenisPekerjaan === "Test Cahaya") {
            return data.targetTestBocor;
          }
        }
      };

      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/secondProcess`,
        {
          id: v4Id,
          tim: dataUser.tim,
          date: dateLaporanSP,
          mesin: mesinSP,
          customer: customerSP,
          produk: foundObject.produk,
          jenisPekerjaan: jenisPekerjaan,
          color: warnaPrinting !== "Pilih Warna" ? warnaPrinting : "",
          jumlahOk: Number(jumlahOkLaporanSP),
          reject: Number(rejectLaporanSP),
          repair:
            dataRepair && dataRepair.length > 0
              ? totalRepair
              : Number(repairLaporanSP),
          jumlahPengerjaan: jumlahPengerjaanSP,
          keterangan: keteranganLaporanSP,
          target: validateTarget(),
          dateSubmit: noFormat,
          operator: dataUser.name,
          isKepala: false,
          isAdmin: false,
          polos: secondFindFromInventory.produk,
          isWarehouse: false,
          bagian: validateRole(),
          dataRepair: dataRepair,
          dataReject: dataReject,
          dataPacking: dataPackingList,
          downtime: Number(downtime),
          month: `${month + 1} ${year}`,
          type: "laporan",
          barangPolos: {
            id: secondFindFromInventory.id,
            produk: secondFindFromInventory.produk,
            color: secondFindFromInventory.color,
          },
        },
        dataUser.auth,
        "",
        ""
      );

      setCustomerSP("Pilih Customer");
      setMesinSP("Pilih Mesin");
      setWarnaPrinting("Pilih Warna");
      setProdukLaporanSP("Pilih Produk");
      setIdBarangPolos("Pilih Produk");
      setJenisPekerjaan("Pilih Jenis Pekerjaan");
      setKeteranganLaporanSP("");
      setJumlahOkLaporanSP("");
      setJumlahPengerjaanSP("");
      setRepairLaporanSP("");
      setRejectLaporanSP("");
      setDowntime("");
      setDataProdukPick();
      setDataRepair([]);
      setDataReject([]);
      setDataPackingList([]);
      setDateReject(today);
      setErrMsgLaporanSP(false);
      setIsSubmit(true);
      setIsErr(false);
    } else {
      if (!isValid) {
        setIsErr(true);
      } else {
        setIsErr(false);
      }

      setErrMsgLaporanSP(true);
    }
  };

  let firstSortProdukPolos =
    dataBarangPolos && dataBarangPolos.find((o) => o.company === customerSP);

  let reStructurePolos = [];
  firstSortProdukPolos &&
    firstSortProdukPolos.data.forEach((element) => {
      reStructurePolos.push({ label: element.produk, value: element.id });
    });

  const handleKirimBarangMasuk = () => {
    if (
      produkMasukSP !== "Pilih Produk" &&
      jumlahMasukSP !== "" &&
      jumlahMasukSP !== "0"
    ) {
      let firtSort =
        dataBarangSP && dataBarangSP.find((o) => o.company === customerSP);
      let secondSort =
        firtSort && firtSort.data.find((o) => o.namaBarang === produkMasukSP);

      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/secondProcess`,
        {
          idBarang: v4Id,
          tim: dataUser.tim,
          customer: customerSP,
          type: "addBarangProduksi",
          total: Number(jumlahMasukSP),
          creator: dataUser.name,
          data: secondSort,
          dateMasuk: today,
        },
        dataUser.auth,
        "",
        ""
      );
      setProdukMasukSP("Pilih Produk");
      setJumlahMasukSP("");
      setCustomerSP("Pilih Customer");
    }
  };

  const exportRejectProduksi = () => {
    const sortData =
      dataMerge &&
      dataMerge.sort(function (a, b) {
        if (a.bagian < b.bagian) {
          return -1;
        }
        if (a.bagian > b.bagian) {
          return 1;
        }
        return 0;
      });

    const filteredDataExcel =
      sortData &&
      sortData.map((obj, index) => {
        return {
          No: index + 1,
          Produk: obj.produk,
          Warna: obj.color,
          Cust: obj.customer,
          Shift: obj.shift,
          Reject: obj.id,
          Jumlah: Number(obj.reject),
          "Tgl Produksi": moment(obj.dateReject).format("DD-MM-YYYY"),
          "Tgl Laporan": moment(obj.date).format("DD-MM-YYYY"),
        };
      });

    const workSheet = XLSX.utils.json_to_sheet(
      filteredDataExcel && filteredDataExcel
    );

    workSheet["!cols"] = [
      { wch: 4 },
      { wch: 40 },
      { wch: 15 },
      { wch: 5 },
      { wch: 10 },
      { wch: 16 },
      { wch: 8 },
      { wch: 10 },
      { wch: 10 },
    ];
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "Barang Jadi");
    XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(
      workBook,
      `Laporan Kelolosan Reject Produksi ke SP ${bulanRejectProduksi} ${tahunRejectProduksi}.xlsx`
    );
  };

  let dataSelect = [];

  rejectDescProduksi &&
    rejectDescProduksi.forEach((element) => {
      dataSelect.push({ value: element.id, label: element.desc });
    });

  let reStructure = [];
  dataProdukPick &&
    dataProdukPick.forEach((element) => {
      reStructure.push({ label: element.produk, value: element.produk });
    });

  return {
    dataUser,
    produkMasukSP,
    setProdukMasukSP,
    jumlahMasukSP,
    setJumlahMasukSP,
    listProduk,
    customerSP,
    handlePickCustomer,
    listProdukPrinting,
    subMenuPrinting,

    jenisPekerjaan,
    mesinSP,
    setMesinSP,
    warnaPrinting,
    setWarnaPrinting,
    produkLaporanSP,
    setProdukLaporanSP,
    setJenisPekerjaan,
    handleKirimLaporanSP,
    keteranganLaporanSP,
    setKeteranganLaporanSP,
    jumlahOkLaporanSP,
    setJumlahOkLaporanSP,
    rejectLaporanSP,
    setRejectLaporanSP,
    repairLaporanSP,
    setRepairLaporanSP,
    jumlahPengerjaanSP,
    setJumlahPengerjaanSP,
    dateLaporanSP,
    setDateLaporanSP,
    errMsgLaporanSP,
    isSubmit,
    setIsSubmit,
    addFields,
    removeFields,
    dataReject,
    addPopUpNewReject,
    setAddPopUpNewReject,
    bagianReject,
    setBagianReject,
    shiftProduksi,
    setShiftProduksi,
    handlePickBagian,
    jumlahReject,
    setJumlahReject,
    alasanRejectSP,
    setAlasanRejectSP,
    dateReject,
    setDateReject,
    downtime,
    setDowntime,
    dataBarangSP,
    handleKirimBarangMasuk,
    dataBarangPolos,
    idBarangPolos,
    setIdBarangPolos,
    dataMerge,
    bulanRejectProduksi,
    setBulanRejectProduksi,
    tahunRejectProduksi,
    setTahunRejectProduksi,
    addPopUpNewPacking,
    setAddPopUpNewPacking,
    datePacking,
    setDatePacking,
    shiftPacking,
    setShiftPacking,
    mesinPacking,
    setMesinPacking,
    operatorPacking,
    setOperatorPacking,
    keteranganPacking,
    setKeteranganPacking,
    jumlahPacking,
    setJumlahPacking,
    dataPackingList,
    addFieldsPacking,
    removeFieldsPacking,
    exportRejectProduksi,
    dataSelect,
    rejectPick,
    setRejectPick,
    reStructure,
    reStructurePolos,
    isErr,
    addPopUpNewRepair,
    setAddPopUpNewRepair,
    dataRepair,
    removeFieldsRepair,
    addFieldsRepair,
    alasanRepairSP,
    setAlasanRepairSP,
    jumlahRepair,
    setJumlahRepair,
    errReject,
    clearErrReject,
    closePopupReject,
    errRepair,
    clearErrRepair,
    closePopupRepair,
  };
};
